import React from "react";
import { useTranslation } from "react-i18next";
import { Heart, Mail, HandHeart } from "lucide-react";

const CONTACT_EMAIL = "support@theprayerwarriors.in";

export default function Footer() {
    const { t } = useTranslation();
    return (
        <footer className="mt-24 border-t" style={{ borderColor: "#E5E0D8", background: "#F5F0E6" }}>
            <div className="mx-auto max-w-7xl px-6 lg:px-10 py-12 grid gap-8 md:grid-cols-4">
                <div className="md:col-span-2">
                    <div className="font-display text-2xl" style={{ color: "#1E1B4B" }}>The Prayer Warriors</div>
                    <div className="text-sm mt-2" style={{ color: "#525252" }}>
                        {t("footer.tagline")}
                    </div>
                    <a href={`mailto:${CONTACT_EMAIL}`} className="mt-4 inline-flex items-center gap-2 text-sm link-underline" style={{ color: "#1E1B4B" }} data-testid="footer-contact-email">
                        <Mail size={14} style={{ color: "#7F1D1D" }} /> {CONTACT_EMAIL}
                    </a>
                </div>
                <div>
                    <div className="text-xs tracking-[0.22em] uppercase mb-3" style={{ color: "#7F1D1D" }}>{t("footer.someone_h")}</div>
                    <ul className="space-y-1.5 text-sm" style={{ color: "#1E1B4B" }}>
                        <li>{t("footer.someone_1")}</li>
                        <li>{t("footer.someone_2")}</li>
                        <li>{t("footer.someone_3")}</li>
                    </ul>
                </div>
                <div>
                    <div className="text-xs tracking-[0.22em] uppercase mb-3" style={{ color: "#7F1D1D" }}>{t("footer.communion_h")}</div>
                    <div className="text-sm" style={{ color: "#525252" }}>
                        {t("footer.communion_body")}
                    </div>
                </div>
            </div>

            {/* Thanks note */}
            <div className="border-t" style={{ borderColor: "#E5E0D8" }}>
                <div className="mx-auto max-w-7xl px-6 lg:px-10 py-8" data-testid="footer-thanks">
                    <div className="flex items-start gap-3">
                        <div className="h-9 w-9 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: "#1E1B4B", color: "#D4AF37" }}>
                            <HandHeart size={16} />
                        </div>
                        <div>
                            <div className="text-xs tracking-[0.22em] uppercase mb-1.5" style={{ color: "#7F1D1D" }}>{t("footer.thanks_h")}</div>
                            <div className="font-display text-lg sm:text-xl leading-snug max-w-3xl" style={{ color: "#1E1B4B" }}>
                                {t("footer.thanks_body")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="border-t" style={{ borderColor: "#E5E0D8" }}>
                <div className="mx-auto max-w-7xl px-6 lg:px-10 py-5 text-xs flex items-center justify-between flex-wrap gap-2" style={{ color: "#525252" }}>
                    <span>{t("footer.copy")}</span>
                    <span className="flex items-center gap-1.5">{t("footer.made_with")} <Heart size={12} style={{ color: "#7F1D1D" }} /> {t("footer.for_faithful")}</span>
                </div>
            </div>
        </footer>
    );
}
